import Api from '@/services/api.js';
import Store from '../store.js';
export default {
  register(credentials) {
    return Api.post('user/register', credentials)
  },
  login(credentials) {
    return Api.post('user/login', credentials)
  },
  dontUserTokenForRequests() {
    Api.defaults.headers['Authorization'] = null;
  },
  checkAuth() {
    return Api.post('user/checkAuth');
  },
  getTokenFromStorage() {
    return localStorage.getItem('accessToken');
  },
  getRefreshTokenFromStorage() {
    return localStorage.getItem('refreshToken');
  },
  useTokenForRequests(token) {
    Api.defaults.headers['Authorization'] = `Bearer ` + token;
  }

}